import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsDepartmentsDepartmentEditRoute extends Route {
  model() {
    return this.modelFor('settings.departments.department');
  }
}

export default instrumentRoutePerformance(
  SettingsDepartmentsDepartmentEditRoute,
);
